window.isset = function (val) {
    if (typeof val == "undefined" || val == null) {
        return false;
    }
    return true;
};

window.isEmpty = function (data) {
    if (typeof (data) === 'object') {
        if (JSON.stringify(data) === '{}' || JSON.stringify(data) === '[]') {
            return true;
        } else if (!data) {
            return true;
        }
        return false;
    } else if (typeof (data) === 'string') {
        if (!data.trim()) {
            return true;
        }
        return false;
    } else if (typeof (data) === 'undefined') {
        return true;
    } else {
        return false;
    }
};

window.parseBool = function (str) {
    if (str == null)
        return false;

    if (typeof str === 'boolean') {
        return str === true;
    }

    if (typeof str === 'string' && str.toLowerCase() == 'true')
        return true;

    return (parseInt(str) > 0);
};

window.redirect = function (url) {
    location.href = url;
};

window.replace = function (url) {
    location.replace(url);
};

window.consoleLog = function (data) {
    if (window.console && JS_DEBUG) {
        console.log(data);
    }
};

window.coalesce = function (value, default_value) {
    if (isset(value)) {
        return value;
    } else {
        return default_value;
    }
};

window.Array.prototype.unique = function () {
    return this.filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
};

window.viewDateTime = function (date) {
    return isEmpty(date) ? '' : date.substr(0, 19);
};

window.viewDate = function (date) {
    return isEmpty(date) ? '' : date.substr(0, 10);
};

window.viewDateKo = function (date) {
    return isEmpty(date) ? '' : date.substr(0, 4) + '년 ' + date.substr(5, 2) + '월 ' + date.substr(8, 2) + '일';
};

window.getDayOfWeek = function (date) {
    return ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'][new Date(date).getDay()];
};

window.viewTime = function (date) {
    return isEmpty(date) ? '' : date.substr(11, 5);
};

window.viewTimeKo = function (date) {
    if (isEmpty(date)) {
        return '';
    }
    var hour = parseInt(date.substr(11, 2));
    return hour >= 12 ? '오후 ' + hour + ':' + date.substr(14, 2) : '오전 ' + hour + ':' + date.substr(14, 2);
};

window.viewSimpleDateTime = function (date) {
    return isEmpty(date) ? '' : date.substr(5, 5).replace('-', '/') + ' ' + date.substr(11, 5);
};

window.viewTrueFalse = function (value, trueValue, falseValue) {
    return value === true ? trueValue : falseValue;
};

window.viewNumber = function (value) {
    if (!isset(value)) {
        return '';
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

window.viewPhone = function (phone) {
    phone = phone.replace(/-/gi, "");
    return phone.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
};

window.loading = function (command) {
    switch (command) {
        case 'ON':
            $(".btn_prevent").prop("disabled", true);
            $(".btn_loading").html('<i class="fa fa-lg fa-circle-notch fa-spin"></i>&nbsp;');
            break;

        case 'OFF':
            $(".btn_prevent").prop("disabled", false);
            $(".btn_loading").html('');
            break;
    }
};

window.checkPhone = function (phone) {
    phone = phone.replace(/-/gi, "");
    var regex = new RegExp('^01[0-9]{8,9}$');
    return regex.test(phone);
};

window.getDowClass = function (dow) {
    switch (dow) {
        case '0':                 // 일요일
            return 'text-danger';
        case '6':                 // 토요일
            return 'text-primary';
        default:
            return '';
    }
};


window.viewShortDateTime = function (dateString) {
    if (!isset(dateString)) {
        return '';
    }
    return dateString.substr(5, 14).replace('-', '/');
};

window.viewShortDateMin = function (dateString) {
    if (!isset(dateString)) {
        return '';
    }
    return dateString.substr(5, 11).replace('-', '/');
};

window.viewOnlyDate = function (dateString) {
    return dateString.substr(5, 10).replace('-', '/');
};

window.viewDateHour = function (dateString) {
    return dateString.substr(0, 16);
};

window.badge = function (type, text) {
    return '<h5><span class="badge badge-' + type + ' w50px">' + text + '</span></h5>';
};

window.getBadge = function (type, text) {
    return '<button class="btn btn-sm btn-' + type + ' pt-0 pb-0 phone_cert align-middle mb-1">' + text + '</button>';
};

window.setClickableRow = function () {
    $(".clickable_row").click(function () {
        if ($(this).hasClass("table-info"))
            $(this).addClass('table-info');
        else
            $(this).addClass('table-info').siblings().removeClass('table-info');
    })
};

window.viewDistance = function (distance) {
    distance = parseFloat(distance).toFixed(2);

    if (distance < 1) {
        distance = distance * 1000;
        distance = parseInt(distance);
        distance = distance + 'm';
    } else {
        distance = distance + 'km';
    }
    // else if (distance < 10) {
    //     distance = distance + 'km';
    // } else {
    //     distance = parseInt(distance) + 'km';
    // }
    return distance;
};

window.viewPastTime = function (loginTime) {
    var timeArray, timeInfo, hour, min, sec;

    timeArray = loginTime.split(',');

    hour = parseInt(timeArray[0]);
    min = timeArray[1];
    sec = timeArray[2];

    if (hour > 0) {
        timeInfo = hour.toString() + '시간 전'
        // timeInfo   = hour.toString() + '시간 ' + min.toString() + '분';
        // min = (hour * 60) + parseInt(min);
        // timeInfo   = min.toString() + '분 ' + sec.toString() + '초';
    } else {
        if (parseInt(min) > 0) {
            // timeInfo = parseInt(min).toString() + '분 ' + sec.toString() + '초';
            timeInfo = parseInt(min).toString() + '분 전 '
        } else {
            timeInfo = parseInt(sec).toString() + '초 전';
        }
    }

    return timeInfo;
    // time_info_array = time_info.split('');
    // time_info_array = time_info_array.reverse();

};

window.getOtherGender = function (gender) {
    if (gender === 'F') {
        return 'M';
    } else {
        return 'F';
    }
};

window.getArea = function (area_code1, area_code2) {
    return AREA_CODE1[area_code1] + ' ' + AREA_CODE2[area_code1][area_code2];
};

window.getPosition = function () {
    var send_data = 'areaCode1=' + $("#areaCode1 option:selected").val() + '&areaCode2=' + $("#areaCode2 option:selected").val();
    ajaxCall('/common/position', send_data, function (json) {
        var coords = new daum.maps.LatLng(json.result['lat'], json.result['lng']);
        map.setCenter(coords);
    });
};


window.setSelect = function (select_id, data_array, select_value, except_first) {
    var option;
    if (typeof except_first == "undefined" || except_first == null) {
        except_first = false;
    }
    //  select_id.children('option:not(:first)').remove();
    select_id.children('option').remove();
    var i = 0;
    $.each(data_array, function (i, data) {
        if (except_first) {
            if (i == 0) {
                return true;
            }
        }
        if (i == select_value) {
            option = "<option value='" + i + "' selected>" + data + "</option>";
        } else {
            option = "<option value='" + i + "'>" + data + "</option>";
        }
        select_id.append(option);
    });
    // for (var i in data_array) {
    //     if (except_first) {
    //         if (i == 0) {
    //             continue;
    //         }
    //     }
    //     consoleLog('i:' + i);
    //     if (i == select_value) {
    //         option = "<option value='" + i + "' selected>" + data_array[i] + "</option>";
    //     } else {
    //         option = "<option value='" + i + "'>" + data_array[i] + "</option>";
    //     }
    //     consoleLog(option);
    //     select_id.append(option);
    // }
};

window.createMap = function (lat, lng, id, level, is_draggable) {
    id = coalesce(id, 'map');
    level = coalesce(level, 4);
    is_draggable = coalesce(is_draggable, true);

    var mapContainer = document.getElementById(id),
        mapOption = {
            center: new daum.maps.LatLng(lat, lng),
            draggable: is_draggable,
            level: level
        };

    return new daum.maps.Map(mapContainer, mapOption);
};

window.createMarker = function (map, lat, lng, title, icon, zindex) {

    zindex = coalesce(zindex, 999);

    var marker = new daum.maps.Marker({
        map: map,
        position: new daum.maps.LatLng(lat, lng),
        title: title,
        image: icon,
        zIndex: zindex
    });

    return marker;
};

window.createGenderMarker = function (image_url, map, lat, lng, title, gender, age) {

    var markerSize = new daum.maps.Size(30, 30);
    var markerImage;
    if (typeof age === "undefined") {
        markerImage = new daum.maps.MarkerImage(image_url + "/images/common/marker/marker_" + gender + ".png", markerSize);
    } else {
        markerImage = new daum.maps.MarkerImage(image_url + "/images/common/marker/marker_" + gender + "_" + age + ".png", markerSize);
    }

    return new daum.maps.Marker({
        map: map,
        position: new daum.maps.LatLng(lat, lng),
        title: title,
        image: markerImage,
        zIndex: 9999
    });
}


window.getDistance = function (lat1, lng1, lat2, lng2) {
    var R = 6371; // km
    var dLat = (lat2 - lat1).toRad();
    var dLon = (lng2 - lng1).toRad();
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1.toRad()) * Math.cos(lat2.toRad()) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
};

window.getMapLevel = function (length) {

    length = parseFloat(length);

    if (length < 0.5) {
        return 5;
    } else if (length < 1) {
        return 8;
    } else if (length < 5) {
        return 9;
    } else if (length < 10) {
        return 10;
    } else if (length < 20) {
        return 11;
    } else if (length < 50) {
        return 12;
    } else if (length < 100) {
        return 13;
    }
    // else if (length < 500) {
    //     return 14;
    // }
    else {
        return 14;
    }
};

window.toastAlert = function (message, type, delay) {
    delay = coalesce(delay, 3000);

    // $.toast({
    //     text: '<b><pre class="text-white font_small lh_md">' + message + '</pre></b>',
    //     position: 'bottom-center',
    //     stack: 5,
    //     loader: false,
    //     allowToastClose: false,
    //     icon: 'success',
    //     hideAfter: delay,
    //     textAlign: 'left',
    //     bgColor: '#FF1356',
    //     textColor: 'white'
    // })
    toastr.options = {
        closeButton: true,
        // showMethod: 'slideDown',
        // hideMethod: 'slideUp',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut',
        showDuration: 300,
        hideDuration: 0,
        positionClass: 'toast-bottom-center',
        timeOut: 3000,
        // extendedTimeOut: 0,
        closeHtml: '<i class="fas fa-times "></i>',
    };
    toastr.success(message);
};

window.toastGreeting = function (message) {
    delay = coalesce(delay, 5000);
    $.toast({
        text: '<b><pre class="text-white">' + message + '</pre></b>',
        //text: '<b><>">' + message + '</span></b>',
        position: 'bottom-center',
        stack: 10,
        loader: false,
        allowToastClose: false,
        icon: 'success',
        hideAfter: delay,
        textAlign: 'left',
        bgColor: '#FF1356',
        textColor: 'white'
    })
};

window.toastAlertRedirect = function (message, delay, url) {
    delay = coalesce(delay, 2000);
    toastAlert(message, 'normal', delay);
    setTimeout(function () {
        redirect(url);
    }, delay);
};

// photo_view modal open
window.modalPhotoView = function (photo_src, photo_id) {
    if (isset(photo_id)) {
        $("#modal_photo_view_photo_id").val(photo_id);
        $('#btn_delete_on_modal_photo').removeClass("d-none");
    } else {
        $('#btn_delete_on_modal_photo').addClass("d-none");
    }
    $('#modal_photo_view_photo_src').attr('src', photo_src);
    $('#modal_photo_view').modal('show');
};

window.closeModalPhotoView = function () {
    $('#modal_photo_view').modal('hide');
};


// photo source not exist => default photo src
window.getPhotoSrc = function (photoSrc, gender, url) {
    if (isset(photoSrc)) {
        return CDN + photoSrc;
    }
    return url + '/images/common/photo_none_' + gender + '.png?v=7';
};

window.sci = function (form) {
    var t = (window.navigator.maxTouchPoints || 'ontouchstart' in document) ? 'M' : 'P';
    form.append('<input type="hidden" name="nf" value="' + navigator.platform + '" />');
    form.append('<input type="hidden" name="t" value="' + t + '" />');
    //form.append('<input type="hidden" name="c" value="' + is_cookies_enabled() + '" />');
};

window.getPhoto = function (url, photo_src, gender, size, popup, cdn) {

    var photo_url = '';
    var is_popup = true;
    var photo_size = 100;       // 25, 50, 75, 100

    if (isset(popup)) {
        is_popup = popup;
    }

    if (isset(photo_src)) {
        photo_url = cdn + photo_src;
    } else {
        is_popup = false;
        photo_url = url + '/images/common/photo_none_' + gender + '.png?v=7';
    }

    if (isset(size)) {
        photo_size = size;
    }

    if (is_popup) {
        return '<img src="' + photo_url + '" class="w-' + photo_size + ' pointer" onClick="modalPhotoView(\'' + photo_url + '\');">';
    } else {
        return '<img src="' + photo_url + '" class="w-' + photo_size + '">';
    }
}


//
window.pagination = function (form_id, total_num, callback, pagination_id, page_count) {
    if (typeof page_count == "undefined") {
        page_count = 10;
    }

    // page_num, list_count default setting
    if ($("#" + form_id + ' [name="page_num"]').length == 0) {
        alert('page_num not defined!');
        return;
    }

    if ($("#" + form_id + ' [name="list_count"]').length == 0) {
        alert(list_count_id + ' not defined!');
        return;
    }

    if (typeof pagination_id == "undefined") {
        pagination_id = 'pagination';
    }

    var page_num = $("#" + form_id + ' [name="page_num"]').val() != '' ? $("#" + form_id + ' [name="page_num"]').val() : 1;
    var list_count = $("#" + form_id + ' [name="list_count"]').val() != '' ? $("#" + form_id + ' [name="list_count"]').val() : 10;

    var total_page_num = Math.ceil(total_num / list_count);
    var start_page_num = Math.ceil(page_num / page_count) * page_count - page_count + 1;
    var end_page_num = start_page_num + page_count - 1;

    if (total_page_num < end_page_num) {
        end_page_num = total_page_num;
    }

    var previous_page_num = start_page_num - 1;
    var next_page_num = end_page_num + 1;

    var row = '';
    row += '<nav class="pt-1 pb-1">';
    row += '<div class="row">';
    row += '<div class="col-2 pr-0">';
    row += '<ul class="pagination mb-0">';
    row += '<li class="page-item disabled"><a class="page-link" href="#">totalCount: ' + viewNumber(total_num) + '</a></li>';
    row += '</ul>';
    row += '</div>';

    row += '<div class="col-8">';
    row += '<ul class="pagination mb-0 justify-content-center">';

    // first & previous
    if (parseInt(page_num) <= page_count) {
        row += '<li class="page-item disabled"><a class="page-link" href="#">&lt;&lt;</a></li>';
        row += '<li class="page-item disabled"><a class="page-link" href="#">&lt;</a></li>';
    } else {
        row += '<li class="page-item"><a class="page-link" href="#" data-page-num=1>&lt;&lt;</a></li>';
        row += '<li class="page-item"><a class="page-link" href="#" data-page-num=' + previous_page_num + '>&lt;</a></li>';
    }

    for (var i = start_page_num; i <= end_page_num; i++) {
        if (parseInt(page_num) === parseInt(i))
            row += '<li class="page-item active"><a class="page-link" href="#" data-page-num=' + i + '>' + i + '</li>';
        else
            row += '<li class="page-item"><a class="page-link" href="#" data-page-num=' + i + '>' + i + '</li>';
    }

    // last & next
    if (total_page_num <= end_page_num) {
        row += '<li class="page-item disabled"><a class="page-link" href="#">&gt;</a></li>';
        row += '<li class="page-item disabled"><a class="page-link" href="#">&gt;&gt;</a></li>';
    } else {
        row += '<li class="page-item"><a class="page-link" href="#" data-page-num=' + next_page_num + '>&gt;</a></li>';
        row += '<li class="page-item"><a class="page-link" href="#" data-page-num=' + total_page_num + '>&gt;&gt;</a></li>';
    }
    row += '</ul>';
    row += '</div>';

    row += '<div class="col-2">';
    row += '</div>';

    row += '</nav>';

    $("#" + pagination_id).html(row);

    $("#" + pagination_id + " a").click(function () {
        // $("#" + page_num_id).val($(this).data("page-num"));
        $("#" + form_id + ' [name="page_num"]').val($(this).data("page-num"));
        callback();
    });
};

window.setCookie = function (name, value, exp) {
    var date = new Date();
    date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
};

window.getCookie = function (name) {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? value[2] : null;
};

window.deleteCookie = function (name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};